// src/features/catalogs/catalogCrudApi.ts
import axios from "@/api/axios-config";
import type { SnowflakeId } from "@/types/snowflake";
import type { CatalogApi, CatalogRecord } from "./types";

// 广集 nameFields:各 catalog 字段名略不同(有无 serviceLineCode),后端按实际存在的列返回。
// catalog 标准化(CATALOG_STANDARDIZATION_FE_HANDOFF)后状态字段统一为 isEnabled(旧 isActive 已废)。
// orderBy 必须是模型真实存在的可排序列,否则后端 400 —— 默认 sortOrder,
// workflow_entity_stage 用 displayOrder(见 opts.sortField)。
function lookupBody(sortField: string) {
  return {
    nameFields: `id code label labelI18n serviceLineCode iconUrl ${sortField} isEnabled description descriptionI18n`,
    orderBy: sortField,
  };
}

/** 按统一契约(spec §9)给一个 base 生成 CRUD client。 */
export function makeCatalogApi(base: string, opts?: { sortField?: string }): CatalogApi {
  const body = lookupBody(opts?.sortField ?? "sortOrder");
  return {
    search: (params) => axios.post(`${base}/search`, params) as Promise<unknown>,
    lookup: () => axios.post(`${base}/lookup`, body) as Promise<CatalogRecord[]>,
    get: (id: SnowflakeId) => axios.get(`${base}/${id}`) as Promise<CatalogRecord>,
    create: (data) => axios.post(`${base}`, data) as Promise<CatalogRecord>,
    update: (id: SnowflakeId, data) => axios.put(`${base}/${id}`, data) as Promise<CatalogRecord>,
    remove: (id: SnowflakeId) => axios.delete(`${base}/${id}`) as Promise<void>,
  };
}

// 各 generic catalog 实例。skill/position/service-line 在 /system/*;workflow_entity_stage
// 后端真实路由是 /pms/workflow-entity-stages(无 /pms/workflow-stages 端点)。
// 状态字段统一 isEnabled、系统行用 isLocked。
export const skillsApi = makeCatalogApi("/system/skills");
export const positionsApi = makeCatalogApi("/system/positions");
export const serviceLinesApi = makeCatalogApi("/system/service-lines");
export const workflowStagesApi = makeCatalogApi("/pms/workflow-entity-stages", { sortField: "displayOrder" });
